import React, { memo } from 'react';
import ReactDom from 'react-dom';

import { ConnectedNotifications as Notifications } from './store/connect';

const el = document.querySelector('.notifications-portal');

export const NotificationsPortal = memo(() => {
	return el === null ? null : ReactDom.createPortal(<Notifications dataset={el.dataset} />, el);
});
